import { Injectable } from '@angular/core';
import {ActivatedRoute, CanLoad, Route, Router, UrlSegment, UrlTree} from '@angular/router';
import { Store } from '@ngxs/store';
import {map, Observable, of, take} from 'rxjs';
import { UserState } from './state/user.state';

/**
 * Biztositjuk hogy a user-nek van mar jelszava
 */
@Injectable({ providedIn: 'root' })
export class RequirePasswordGuard implements CanLoad {
  constructor(private router: Router, private store: Store) {
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    console.log(route, segments);
    return this.store.select(UserState.hasPassword).pipe(
      take(1),
      map(hasPassword => hasPassword || this.router.parseUrl('/user/set-password'))
    );
  }
}
